/* THRIFT AVE — cart drawer carousel (19/09/2026)
 * "+ Aggiungi" on a card = POST /cart/add.js right away; the drawer is re-rendered through the
 * theme's cart-drawer.renderContents(state, skipOpen=true) — the drawer is already open — so the
 * lines, the gift engines, the checkpoints bar, the summary and the carousel itself (fresh gap,
 * fresh stamps, the unique piece gone) all follow from one render. Delegated listener: it
 * survives every re-render of #CartDrawer. Never publish(PUB_SUB_EVENTS.cartUpdate) after
 * renderContents (Shrine bug, see ta-cart-drawer.js): our own cart:updated event is enough.
 */
(function () {
  'use strict';
  if (window.__taCartCarousel) return;
  window.__taCartCarousel = true;

  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { throw data; }
        return data;
      });
    });
  }

  function render(state) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && state && state.sections) {
      try { drawer.renderContents(state, true); } catch (e) { /* refreshes on next open anyway */ }
    }
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state, source: 'ta-cart-carousel' } })); } catch (e) {}
  }

  function fail(btn, text) {
    var card = btn.closest('.ta-car__card');
    if (card) card.setAttribute('data-error', '');
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    btn.textContent = text || 'Non disponibile';
    setTimeout(function () {
      if (!btn.isConnected) return;
      btn.textContent = label;
      if (card) card.removeAttribute('data-error');
    }, 2200);
  }

  // 29/10: a box from the carousel must carry the choices of the box already in the cart
  // (Per, Vestibilità, Cosa ti piace, Marche, Mai nella box…): same box product = one more on
  // that line (like its "+", keeps its waist size), other box = new line with the same properties. Before, the second
  // box arrived empty (order #1095).
  function addBox(id, pid) {
    return fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var same = null, props = null;
        for (var i = 0; i < items.length; i++) {
          var p = items[i].properties || {};
          var mine = Object.keys(p).some(function (k) { return k.charAt(0) !== '_' && p[k]; });
          if (!mine) continue;
          if (!props) props = p;
          // same box product (even with another waist variant): one more on the line the customer built
          if (!same && (items[i].variant_id === id || (pid && items[i].product_id === pid))) same = items[i];
        }
        if (same) {
          return post(root() + 'cart/change.js', { id: same.key, quantity: same.quantity + 1, sections: SECTIONS, sections_url: window.location.pathname });
        }
        var line = { id: id, quantity: 1 };
        if (props) line.properties = props;
        return post(root() + 'cart/add.js', { items: [line], sections: SECTIONS, sections_url: window.location.pathname });
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-ta-car-add]');
    if (!btn) return;
    if (btn.tagName !== 'BUTTON') {
      var own = btn.closest('.ta-car__card');
      own = own && own.querySelector('button[data-ta-car-add]');
      if (own) btn = own;
    }
    e.preventDefault();
    if (busy) return;
    var id = Number(btn.getAttribute('data-ta-car-add'));
    if (!id) return;
    var host = btn.closest('ta-cart-carousel');
    var errorText = (host && host.getAttribute('data-error')) || 'Non disponibile';
    busy = true;
    btn.setAttribute('aria-busy', 'true');
    var send = btn.hasAttribute('data-ta-car-box') ? addBox(id, Number(btn.getAttribute('data-ta-car-box'))) :
      post(root() + 'cart/add.js', { items: [{ id: id, quantity: 1 }], sections: SECTIONS, sections_url: window.location.pathname });
    send
      .then(function (data) {
        render(data);
      })
      .catch(function (err) {
        fail(btn, (err && (err.description || err.message)) ? errorText : errorText);
      })
      .then(function () {
        busy = false;
        if (btn.isConnected) btn.removeAttribute('aria-busy');
      });
  });
})();
